import styled from '@emotion/styled'
import { Menu } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const MenuStyled = styled(Menu)`
  div {
    box-shadow: ${theme.effects.boxShadow['rule-01']};
  }
`
